<template>
   <div class="bg-light pt-3 pb-5" :class="[{'pt-lg-5' : !isChild}]">
      <b-container fluid>
         <b-row>

            <b-col v-if="!isChild" cols="12" lg="3" xl="2" class="p-0">
               <DashUserNav></DashUserNav>
            </b-col>

            <b-col cols="12" :lg="!isChild ? 9 : 12" xl="10" class="pl-3 pl-lg-3 mt-3">

               <div v-if="!isChild">
                  <h5 class="text-center text-md-left">Cadastro Complementar para Anfitriões</h5>
                  <hr>
               </div>

               <div v-show="active === 0" class="transition-box">
                  <el-card
                     v-if="active === 0 || this.step === 'conta-bancaria'"
                     class="box-card dashboard-card">
                     <BankAccount />
                  </el-card>
               </div>
            </b-col>
         </b-row>
      </b-container>


   </div>
</template>

<script>
import DashUserNav from "@/components/DashUserNav";
import UserService from '@/services/user.service'
import {photoIsOK} from "@/helpers";
import PaymentService from "@/services/payment";
import Permission from "@/helpers/Permission";
import imageCompression from "browser-image-compression";
import BankAccount from "@/views/dashboard/owner-panel/BankAccount";

export default {
   name: 'FinalizeRegister',
   components: {
      DashUserNav,
      BankAccount
   },
   props: {
      isChild: {
         type: Boolean,
         default: false
      },
      step: {
         type: String,
         default: '',
         required: false
      },
   },
   data() {
      return {
         loading: {
            btnDocuments: false,
            sendFiles: false,
            checkDocumentsList: false
         },
         user: {},
         active: 0,
         fileDocument: [],
         fileSelfie: [],
         documentRaw: {},
         selfieRaw: null,
         docsUser: null,
         uploadedFiles: false,
         docID: null,
         docSELFIE: null,
         tempfileDocument: false,
         tempSelfie: false,
         url: `/painel/finalizar-cadastro/`,
         documentsList: [],
         documentsSelected: [],
         accessType: ''
      }
   },
   async beforeMount() {
      if (this.step) {
         if (this.step === 'documentos') {
            this.active = 1
            await this.handleDocumentsList()
         }
      }
   },
   async mounted() {
      await this.getUser();
      this.user = this.userData.data

      if (this.user) {

         const ready = new Permission(this.user).userIsReady()

         if (!ready) {
            await this.$router.push({name: 'profile'})
         }

         this.digitalAccount = this.user.digitalAccount ? this.user.digitalAccount : null


         if (this.digitalAccount && this.user.digitalAccount.docID && this.user.digitalAccount.docSELFIE) {
            this.docID = this.user.digitalAccount.docID
            this.docSELFIE = this.user.digitalAccount.docSELFIE
         }
      }

   },
   methods: {

      async getUser() {
         await this.$store.dispatch('user/get', await UserService.getUserData())
      },

      setDocument(file, junoDocInfo) {

         setTimeout(() => {

            if (photoIsOK(file, 18)) {

               let imageFile = file.raw;

               let options = {
                  maxSizeMB: 3,
                  maxWidthOrHeight: 2000,
                  useWebWorker: true,
                  maxIteration: 20,
                  onProgress: () => false
               };

               imageCompression(imageFile, options)
                  .then((compressedFile) => {
                     // let _id = id.replace(/_/g, "")
                     this.documentRaw[junoDocInfo.id] = new File([compressedFile], file.name, {type: file.raw.type})
                     this.documentsSelected.push(junoDocInfo.id)
                  })
                  .catch(function (error) {
                     alert(`Ops, algo deu errado. Erro: ${error}`)
                  });

            } else {
               this.fileDocument = [];
            }

         }, 100)

      },

      async sendDocuments() {

         try {

            this.loading.btnDocuments = true;
            this.loading.sendFiles = true;

            var formData = new FormData();

            Object.keys(this.documentRaw).forEach(key => {
               formData.append(key, this.documentRaw[key]);
            });

            const documents = await PaymentService.Documents(formData)
            this.loading.sendFiles = false;
            this.loading.btnDocuments = false;

            if (documents) {
               this.$message({
                  message: documents.message,
                  type: 'success'
               });

               this.loading.sendFiles = false;
               this.loading.btnDocuments = false;
               this.goTo('aprovacao')
            }

         } catch (e) {
            this.loading.sendFiles = false;
            this.loading.btnDocuments = false;
         }
      },

      handleRemove(file, id) {

         if (id === 'fileDocument') {
            this.documentRaw = null;
            this.clearUpload('tempfileDocument', 'tempfileDocument')
         }
         if (id === 'fileSelfie') {
            this.selfieRaw = null;
            this.clearUpload('tempSelfie', 'selfieRaw')
         }

      },

      clearUpload(id, type) {
         delete this.documentRaw[type]
         this.documentsSelected = this.documentsSelected.filter(item => item !== type)
         this.$refs[type].clearFiles();
      },

      // eslint-disable-next-line no-unused-vars
      handleExceed() {
         this.$message.warning(`Somente 1 arquivo neste campo!`);
      },

      goToDocuments() {
         this.$router.push({name: 'my-bikes',  params: { page: 'dados-bancario' } })
      },

      goTo(step) {
         this.$router.push(`${this.url}${step}`);
      },

      async handleDocumentsList() {
         try {
            this.loading.checkDocumentsList = true
            this.documentsList = await PaymentService.ListDocuments()
            this.loading.checkDocumentsList = false
         } catch (e) {
            this.loading.checkDocumentsList = false
            this.$message.error(e.response.data.message);
         }
      },

      redirect(page) {
          window.location.href = page;
      }


   },
   computed: {
      currentUser() {
         return this.$store.state.auth.user;
      },
      userData() {
         return this.$store.state.user
      },
      isPJ() {
         return this.$store.state.user.data.additionalInformation.type === 'pj' || false
      },
      isSendDocuments() {
         return this.documentsList.filter(f => f.approvalStatus !== 'APPROVED' && f.approvalStatus !== 'VERIFYING')
      },
      allApproved() {
         return this.documentsList.filter(f => f.approvalStatus !== 'APPROVED' && f.approvalStatus !== 'VERIFYING')
      }
   },
   watch: {
      '$route': {
         handler: async function (page) {
            if (page.name === 'my-bikes') {
               if (page.params.page === 'documentos') {
                  this.accessType = 'my-bikes'
               }
            }
            switch (page.params.step) {
               case 'conta-bancaria':
                  this.active = 0;
                  break
               case 'documentos':
                  await this.handleDocumentsList()
                  this.active = 1;
                  break
               case 'aprovacao':
                  this.active = 2;
                  break
               case 'aprovada':
                  this.active = 3;
                  break
               case 'reprovada':
                  this.active = 4;
                  break
               default:
                  this.active = 0;
            }
         },
         deep: true,
         immediate: true
      }
   }
}
</script>

<style lang="scss">

.clearButton {
   transform: translate(0, 17px);
   display: block;

   @media only screen and (max-width: 512px) {
      margin-bottom: 22px !important;
      transform: translate(0, 15px) !important;
   }

   &.selfie {
      margin-bottom: 15px !important
   }
}

.uploadButton, .clearButton, .upload-demo, .el-upload, .sendFiles {
   @media only screen and (max-width: 512px) {
      width: 100% !important;
      display: block;
   }
}

.border-dashed {
   border: dashed 1px #ccc;
   border-radius: 5px;
   padding: 25px;
}

.el-upload-list__item-thumbnail {
   object-fit: cover;
}

.el-upload.el-upload--picture-card {
   border: 0;
   height: auto;
}

.upload-selfie {

   @media only screen and (max-width: 512px) {
      text-align: center;
      margin-top: 40px !important;
   }

   @media only screen and (min-width: 512px) {
      .el-upload--picture-card {
         line-height: 36px;
      }
   }


   .el-upload-list__item-preview {
      display: none !important;
   }

   .el-upload-list--picture-card .el-upload-list__item-actions span + span {
      margin-left: 0 !important;
   }
}

.upload-docs {
   li.el-upload-list__item.is-ready .el-icon-close {
      display: block;
      font-size: 25px;
      color: red;
      opacity: 1;
      top: 11px;
      right: 12px;
   }
}

.upload-docs[data-approvalstatus='REJECTED'] {
 .border-dashed {
    border: 2px solid red;
 }
}


</style>
